import { createFileRoute } from '@tanstack/react-router'

import { PrivacyPolicyPage } from '@/components/infoPages/PrivacyPolicyPage'

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicyPage,
})

